PJQ.Sortable = class {
	constructor($el, options = {}) {
		let self = this;
		self.$el = $el;
		self.options = _.defaults(options, {
			selectedClass: "selected",
			start: function () {
				self.onStart();
			},
			stop: function (e, ui) {
				self.onStop(e, ui);
			}
		});
		if (_.size(self.$el) > 0 && _.size(self.options.items) > 0) {
			self.$el.find(self.options.items).addClass('sortable-item');
			if (self.options.multiple) {
				self.$el.multisortable(self.options);
			}
			else {
				self.$el.sortable(self.options);
			}
		}
	}

	refreshPositions() {
		if (this.options.multiple) {
			this.$el.multisortable("refreshPositions");
		}
		else {
			this.$el.sortable("refreshPositions");
		}
	}

	getSelected() {
		return this.$el.find(this.options.items).filter("." + this.options.selectedClass);
	}

	moveSelectedTop() {
		this.getSelected().prependTo(this.$el);
		this.$el.scrollTop(0);
		this.onStop();
	}

	moveSelectedBottom() {
		this.getSelected().appendTo(this.$el);
		this.$el.scrollTop(this.$el.height() + 100);
		this.onStop();
	}

	onStop(e, ui) {
		if (typeof this.options.onStop === 'function') {
			this.options.onStop(e, ui);
		}
	}

	onStart() {
		if (typeof this.options.onStart === 'function') {
			this.options.onStart();
		}
	}
};